import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

export function Badge({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-block px-3 py-1 text-xs font-medium tracking-wider uppercase",
        "border border-[var(--color-border)] rounded-full",
        "text-[var(--color-fg-secondary)]",
        "font-[family-name:var(--font-mono)]",
        className
      )}
    >
      {children}
    </span>
  );
}
